<template>
  <div
    class="next-ticket-waiting"
    title=""
  >
    <div
      id="global-ticket-priority"
      :class="waitTime | ticketPriority"
      class="ticket-priority"
    />
    <span id="global-ticket-wait-time">{{ waitTime | formatWaitTime }}</span>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  filters: {
    formatWaitTime (waitTime) {
      if (typeof waitTime === 'string') {
        let array = waitTime.split(':')
        if (array[0] !== '0') {
          return array[0] + 'h ' + array[1] + 'min'
        }
        return array[1] + 'min'
      } else {
        return '--'
      }
    },
    ticketPriority (waitTime) {
      if (waitTime) {
        let data = waitTime.split(':')
        if (Number(data[0] > 0)) {
          return 'high-priority'
        } else if (Number(data[1]) < 30) {
          return 'low-priority'
        } else {
          return 'medium-priority'
        }
      }
    }
  },
  props: {
    nextTicket: {
      type: Object,
      required: false,
      default: null
    }
  },
  data () {
    return {
      now: Date(),
      interval: undefined
    }
  },
  computed: {
    waitTime () {
      if (this.nextTicket === null) {
        return null
      }
      return moment().utc().subtract(moment(this.nextTicket.createdAt).format('x'), 'ms').format('H:m')
    }
  },
  mounted () {
    this.interval = setInterval(() => {
      this.interval = moment().utc()
    }, 30000)
  },
  beforeDestroy () {
    clearInterval(this.interval)
  }
}
</script>
